import Rodape from "../../components/rodape";
import BannerProjects from "../../components/bannerProjects";
import BusinessOtimize from "../../components/businessOtimize";
import ErpMarcas from "../../components/erpMarcas";
import Diferenciais from "../../components/diferenciais";
import ErpIdeal from "../../components/erpIdeal";
import MenosCusto from "../../components/menosCusto";
import ErpExpertiseBrand from "../../components/erpExpertiseBrand";

function ErpExpertise() {
    return (
        <>
            <BannerProjects
                backgroundImage="../assets/cover-erp-expertise.png"
                bgMobile="../assets/cover-erp-expertise-mobile.png"
                title="/ERP"
                titleBold="EXPERTISE"
                iconSrc="../assets/icone-projectiva-omnicore.png"
                iconAlt="Projectiva Omnicore"
                iconText="omni"
                iconTextBold="core"
                descriptionBold=""
                description={
                    <>
                        Alinhamos estratégia, processos e tecnologia para
                        otimizar sua operação e impulsionar a performance da sua
                        empresa.
                    </>
                }
                footerText="VERTICAL SOLUTIONS | ERP"
                buttonText="Quero me conectar"
                buttonColor="from-[#4B3BDB] via-[#4B3BDB] to-[#A002CB]"
                brand="omnicore"
            />
            <ErpMarcas />
            <BusinessOtimize
                title={
                    <>
                        <span className="font-inter-bold bg-clip-text text-transparent bg-gradient-to-r from-[#4B3BDB] via-[#4B3BDB] to-[#A002CB]">
                            Muito além do suporte técnico:
                        </span>
                        <br />
                        a nova forma de fazer seu ERP trabalhar
                        <br />
                        estrategicamente.
                    </>
                }
                buttonText="Otimize seu negócio"
                backgroundImage="../assets/banner-suporte-tecnico.png"
                bgMobile="../assets/banner-suporte-tecnico-mobile.png"
                buttonLink="/"
            />
            <ErpExpertiseBrand
                logo="../assets/erp-marcas-4.svg"
                description={
                    <>
                        <h2 className="font-inter-regular leading-relaxed">
                            A TOTVS é líder absoluta no mercado brasileiro de
                            ERP, com soluções que atendem empresas de todos os
                            portes e setores. Na Omnicore, apoiamos sua empresa
                            na implementação, evolução e integração de soluções
                            TOTVS para que seja um ativo de grande valor para o
                            negócio.
                        </h2>
                    </>
                }
                bg="bg-[#040116]"
                cards={[
                    {
                        icon: "../assets/servicos/protheus_icon.svg",
                        title: "Protheus",
                        text: "Especialistas em Protheus, atuamos com implantação, suporte e evolução nos módulos de compras, fiscal, financeiro, estoque, vendas, produção e RH. Entregamos integrações, customizações e performance com foco no negócio.",
                    },
                    {
                        icon: "../assets/servicos/rm_icon.svg",
                        title: "RM",
                        text: "Entregamos  implantação, suporte e evolução do TOTVS RM em módulos como folha, ponto, recrutamento, educação, financeiro, compras, contratos e patrimônio. Especialistas em integrar, ajustar e otimizar sua operação com inteligência.",
                    },
                    {
                        icon: "../assets/servicos/fluig_icon.svg",
                        title: "Fluig",
                        text: "Somos especialistas em Fluig, com foco na automação de processos, gestão de documentos e criação de portais colaborativos. Desenvolvemos workflows personalizados, integrações com ERPs e soluções sob medida para impulsionar produtividade e controle.",
                    },
                ]}
            />
            <ErpExpertiseBrand
                logo="../assets/erp-marcas-3.svg"
                description={
                    <>
                        <h2 className="font-inter-regular leading-relaxed">
                            Reconhecidos por nossa atuação sólida com as
                            soluções da Senior, entregamos ERP, HCM, folha de
                            pagamento, acesso e segurança.
                            <br />
                            Mais do que conhecimento técnico, oferecemos uma
                            parceria dedicada, com foco em eficiência,
                            integração de processos e eliminação de gargalos
                            operacionais.
                        </h2>
                    </>
                }
                bg="bg-gradient-to-b from-[#0A0020] via-[#110339] to-[#1A0B5C]"
                cards={[
                    {
                        icon: "../assets/servicos/erp_senior_icon.svg",
                        title: "ERP",
                        text: "Atuamos com uma abordagem consultiva e técnica, indo além da simples configuração do sistema. Nosso diferencial está na visão estratégica e nas soluções sob medida para cada operação, com entregas de alta performance e total aderência ao negócio.",
                    },
                    {
                        icon: "../assets/servicos/hcm_icon.svg",
                        title: "HCM",
                        text: "Vamos além da implementação do sistema: atuamos como parceiros estratégicos do seu negócio. Nossa abordagem visa reduzir impactos operacionais, eliminar gargalos críticos de SLA, realizar parametrizações precisas com suporte contínuo e entregar soluções alinhadas às necessidades do seu negócio.",
                    },
                    {
                        icon: "../assets/servicos/ronda_icon.svg",
                        title: "Ronda Acesso",
                        text: "O Ronda é a solução da Senior para gestão de acessos de pessoas e veículos em ambientes corporativos e industriais. Com foco em eficiência e conformidade, entregamos parametrizações, integrações e suporte contínuo — tornando o acesso um processo seguro, fluido e estratégico para o seu negócio.",
                    },
                    {
                        icon: "../assets/servicos/xplatform_icon.svg",
                        title: "XPlatform",
                        text: "Gerenciamos o desenvolvimento, integração e personalização de soluções, na Xplatform da Senior, mapeando e apontando pontos de melhoria na performance do seu Painel.",
                    },
                ]}
            />
            <ErpExpertiseBrand
                logo="../assets/erp-marcas-2.svg"
                description={
                    <>
                        <h2 className="font-inter-regular leading-relaxed">
                            <span className="font-inter-bold">
                                A SAP é referência global em gestão empresarial,
                                com processos robustos e altamente integrados.
                            </span>
                            <br />
                            Atuamos como parceiros estratégicos e protagonistas
                            na construção de soluções SAP que geram valor real.
                            Nossa expertise está no modelo CORE SAP, com domínio
                            em compras, finanças, controladoria, manufatura,
                            fiscal e logística.
                        </h2>
                    </>
                }
                bg="bg-[#040116]"
                cards={[
                    {
                        icon: "../assets/servicos/ecc_icon.svg",
                        title: "ECC",
                        text: (
                            <>
                                <span className="font-inter-bold">
                                    Somos agnósticos: não forçamos a migração,
                                    entregamos soluções alinhadas ao momento do
                                    cliente.
                                </span>{" "}
                                Apoiamos empresas que seguem no SAP ECC 6.0,
                                garantindo suporte contínuo, eficiência e
                                decisões orientadas pelo negócio. Focamos em
                                manter sua operação estável e preparada para
                                evoluir no tempo certo.
                            </>
                        ),
                    },
                    {
                        icon: "../assets/servicos/s4_icon.svg",
                        title: "S/4HANA",
                        text: "Acreditamos que a jornada para o S/4HANA deve partir da realidade do cliente, não de pacotes prontos. Unimos protagonismo técnico, decisões orientadas por valor e execução ágil. Não vendemos roadmap, construímos junto ao cliente, o caminho mais eficiente e seguro para o sistema gerar resultado desde o início.",
                    },
                    {
                        icon: "../assets/servicos/b1_icon.svg",
                        title: "B1",
                        text: "Assumimos a continuidade do SAP Business One com inteligência técnica, foco na evolução dos processos e melhoria contínua da performance do sistema.",
                    },
                ]}
            />
            <ErpExpertiseBrand
                logo="../assets/erp-marcas-1.svg"
                description={
                    <>
                        <h2 className="font-inter-bold leading-relaxed">
                            O SAP Business One (SAP B1) é um sistema ERP voltado
                            para pequenas e médias empresas, que oferece
                            recursos completos de gestão empresarial.{" "}
                            <span className="font-inter-regular">
                                Seus principais diferenciais incluem
                                acessibilidade para PMEs, funcionalidades
                                integradas nas áreas financeira, de estoque,
                                vendas e compras, além de escalabilidade para
                                acompanhar o crescimento dos seus negócios.
                            </span>
                        </h2>
                    </>
                }
                bg="bg-gradient-to-b from-[#0A0020] via-[#110339] to-[#1A0B5C]"
            />
            <MenosCusto />
            <ErpIdeal />
            <Diferenciais
                servicosData={[
                    {
                        icon: "../assets/servicos/expertise_icon.svg",
                        iconHover: "../assets/servicos/expertise_icon.svg",
                        title: "EXPERTISE COMPROVADA",
                        text: (
                            <>
                                Com visão estratégica sobre o negócio, a
                                Omnicore oferece um novo padrão de suporte para
                                SAP, TOTVS e SENIOR sem burocracia, com mais
                                inteligência e total compromisso com o resultado
                                do cliente.
                            </>
                        ),
                        glowColor: "#4B3BDB",
                        url: "",
                    },
                    {
                        icon: "../assets/servicos/abordagem_holistica_icon.svg",
                        iconHover:
                            "../assets/servicos/abordagem_holistica_icon.svg",
                        title: "ABORDAGEM HOLÍSTICA",
                        text: (
                            <>
                                Observamos além da tecnologia, focando também
                                nos processos de negócios e na transformação
                                organizacional necessária para maximizar os
                                benefícios do ERP e ampliar seu desempenho.
                            </>
                        ),
                        glowColor: "#4B3BDB",
                        url: "",
                    },
                    {
                        icon: "../assets/servicos/compromisso_sucesso_icon.svg",
                        iconHover:
                            "../assets/servicos/compromisso_sucesso_icon.svg",
                        title: "COMPROMISSO COM O SUCESSO",
                        text: (
                            <>
                                Somos comprometidos com o sucesso dos clientes.
                                Oferecemos suporte contínuo e customizamos
                                nossas soluções às suas necessidades de
                                evolução.
                            </>
                        ),
                        glowColor: "#4B3BDB",
                        url: "",
                    },
                    {
                        icon: "../assets/servicos/economia_icon.svg",
                        iconHover: "../assets/servicos/economia_icon.svg",
                        title: "ECONOMIA DE CUSTOS PERMANENTE",
                        text: (
                            <>
                                Nossa abordagem busca reduzir os custos
                                operacionais a longo prazo, potencializando uma
                                economia sustentável para sua organização.
                            </>
                        ),
                        glowColor: "#4B3BDB",
                        url: "",
                    },
                    {
                        icon: "../assets/servicos/foco_resultados_icon.svg",
                        iconHover:
                            "../assets/servicos/foco_resultados_icon.svg",
                        title: "FOCO EM RESULTADOS",
                        text: (
                            <>
                                Na Omnicore, o foco é resolver o que realmente
                                importa. Somos a parceira que seu ERP precisava
                                para ampliar resultados e reduzir custos com
                                inteligência.
                            </>
                        ),
                        glowColor: "#4B3BDB",
                        url: "",
                    },
                    {
                        icon: "../assets/servicos/solucoes_inovadoras_icon.svg",
                        iconHover:
                            "../assets/servicos/solucoes_inovadoras_icon.svg",
                        title: "SOLUÇÕES INOVADORAS",
                        text: (
                            <>
                                Impulsionamos a inovação, através das
                                tecnologias de última geração, como análise de
                                dados, automação de processos e IA, para
                                aprimorar a gestão do seu ERP.
                            </>
                        ),
                        glowColor: "#4B3BDB",
                        url: "",
                    },
                ]}
                title={<>Diferenciais</>}
            />
            <BusinessOtimize
                title={
                    <>
                        <span className="font-inter-bold">
                            Amplie a vida do seu ERP com total confiança:
                            modernize seu negócio no seu ritmo
                        </span>
                        , com um suporte que assegura estabilidade, desempenho e
                        continuidade, mesmo em versões antigas.
                    </>
                }
                buttonText="Otimize seu negócio"
                backgroundImage="../assets/banner-erp-expertise.png"
                bgMobile="../assets/banner-erp-expertise-mobile.png"
                buttonLink="/"
            />
            <Rodape />
        </>
    );
}

export default ErpExpertise;
